export const TU_CIBIL_PDF = "https://fastly-production.24c.in/cars24/docs/finance/DOC_TU_CIBIL_Terms_of_Use_1683193533.pdf";
